import { useState } from "react";
import Skeleton from "react-loading-skeleton";

import classes from "./Logo.module.css";

type Size = "xs" | "sm" | "md" | "lg" | "xl";

const sizeMap = {
  xs: 24,
  sm: 32,
  md: 48,
  lg: 64,
  xl: 80,
} as const;

type Props = {
  src?: string;
  size?: Size;
};

export const Logo = ({ src, size = "md" }: Props) => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <div
      className={classes.logo}
      style={{ width: sizeMap[size], height: sizeMap[size] }}
    >
      <img
        className={classes.img}
        src={
          src ??
          "https://www.ciimarketplace.in/media/company_logo/placeholder.jpg"
        }
        onError={({ currentTarget }) => {
          currentTarget.onerror = null; // prevents looping
          currentTarget.src =
            "https://www.ciimarketplace.in/media/company_logo/placeholder.jpg";
        }}
        onLoad={() => setIsLoading(false)}
      />
      {isLoading && (
        <div className={classes.skeleton}>
          <Skeleton width="100%" height="100%" circle />
        </div>
      )}
    </div>
  );
};
